import wordmarkWhite from "../assets/dhc-wordmark.svg";
import wordmarkBlack from "../assets/dhc-wordmark-black.svg";

/**
 * DHC brand lockup: the `dhc.` wordmark (from the DHC design system,
 * hexagon + yellow dot) plus a lowercase "track" suffix in Archivo.
 * White wordmark on dark grounds, black on light — swapped via the
 * theme class since `data-theme` is always set by applyTheme().
 */
export function Wordmark({ className = "" }: { className?: string }) {
  return (
    <span className={`flex items-center gap-2 ${className}`}>
      <img src={wordmarkBlack} alt="dhc." className="h-3.5 w-auto dark:hidden" />
      <img src={wordmarkWhite} alt="dhc." className="hidden h-3.5 w-auto dark:block" />
      <span className="text-sm font-extrabold lowercase tracking-tight text-text-primary">
        track
      </span>
    </span>
  );
}

/** Compact variant for the collapsed icon rail — `dt` with the brand dot. */
export function WordmarkCompact() {
  return (
    <span className="text-sm font-extrabold lowercase tracking-tight text-text-primary">
      dt<span className="text-accent">.</span>
    </span>
  );
}
